import React, { FC } from 'react';
import dynamic from 'next/dynamic';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { Link, Text } from '@shared/ui/atoms';
import { Partners, usePartner } from '@shared/lib/partner';
import { useChatOpen } from '@shared/lib/react';
import { ecosystemLinks, getInternalLinksByPartner } from '../config/links';
import { getContactsByPartner } from '../config/contacts';
const DynamicContactItem = dynamic(() => import('./ContactItem').then(imported => imported.default), {
  ssr: false
});
const Footer: FC = () => {
  const {
    partner
  } = usePartner();
  const {
    openChat
  } = useChatOpen();
  return <FooterWrapper>
      <TopSection>
        <TopLeftSection>
          {partner === Partners.DEFAULT && <TextWrapper>
              <Text family="MTSCompact" size={{
            desktop: 'h6',
            mobile: 'pL'
          }} weight="medium" color="primary">
                МТС&nbsp;Оплата&nbsp;— просто и&nbsp;удобно
              </Text>
              <Text family="MTSCompact" size={{
            desktop: 'pL',
            mobile: 'pM'
          }} weight="medium" color="primary">
                Оплачивайте игры и игровые сервисы
              </Text>
            </TextWrapper>}
          <ContactsWrapper>
            {getContactsByPartner(partner).map(contact => {
            const c = contact.type === 'chat' ? {
              ...contact,
              onClick: openChat
            } : contact;
            return <DynamicContactItem key={c.label} contact={c} />;
          })}
          </ContactsWrapper>
        </TopLeftSection>
        <TopRightSection>
          <InternalLinksWrapper>
            {getInternalLinksByPartner(partner).map(link => <Link key={link.label} href={link.href} color="secondary">
                <Text family="MTSCompact" size={{
              desktop: 'pL',
              mobile: 'pM'
            }} weight="medium">
                  {link.label}
                </Text>
              </Link>)}
          </InternalLinksWrapper>
          {partner === Partners.DEFAULT && <EcosystemLinksWrapper>
              {ecosystemLinks.map(link => <Link key={link.label} href={link.href} color="secondary">
                  <Text family="MTSCompact" size={{
              desktop: 'pL',
              mobile: 'pM'
            }} weight="medium">
                    {link.label}
                  </Text>
                </Link>)}
            </EcosystemLinksWrapper>}
        </TopRightSection>
      </TopSection>
      {partner === Partners.DEFAULT && <BottomSection>
          <Text family="MTSCompact" size={{
        desktop: 'pL',
        mobile: 'pM'
      }} weight="medium" color="secondary">
            © МТС&nbsp;Оплата 2026. Все&nbsp;права защищены
          </Text>
        </BottomSection>}
    </FooterWrapper>;
};
export default Footer;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.secondary;
const FooterWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "FooterWrapper",
  class: "fy2z5ji",
  propsAsIs: false,
  vars: {
    "fy2z5ji-0": [_exp()]
  }
}));
const TopSection = /*#__PURE__*/styled('div')({
  name: "TopSection",
  class: "t1l3l3p1",
  propsAsIs: false
});
const BottomSection = /*#__PURE__*/styled('div')({
  name: "BottomSection",
  class: "b18xhalq",
  propsAsIs: false
});
const TopLeftSection = /*#__PURE__*/styled('div')({
  name: "TopLeftSection",
  class: "t1bg140b",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "thnve05",
  propsAsIs: false
});
const ContactsWrapper = /*#__PURE__*/styled('div')({
  name: "ContactsWrapper",
  class: "ck41ab5",
  propsAsIs: false
});
const TopRightSection = /*#__PURE__*/styled('div')({
  name: "TopRightSection",
  class: "toi1id8",
  propsAsIs: false
});
const InternalLinksWrapper = /*#__PURE__*/styled('div')({
  name: "InternalLinksWrapper",
  class: "i1r72k75",
  propsAsIs: false
});
const EcosystemLinksWrapper = /*#__PURE__*/styled('div')({
  name: "EcosystemLinksWrapper",
  class: "edn6goy",
  propsAsIs: false
});

require("./Footer.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Footer.tsx");